<template>
  <div class="disclaimer-view">
    <h1 class="agreement-title">免责声明</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <p>1. 易软信息科技（惠州）有限公司（以下简称“本公司”）所经营的软件产品，包括音频处理系列软件、视频处理系列软件、效率办公系列软件（以下简称“本公司软件产品”）等。严禁用户将本公司软件产品用于任何非法用途，如用户不能遵守此规定，对于因用户使用本公司软件产品而造成自身或他人隐私泄露等任何不良后果，均由用户自行承担，本公司不负任何责任。</p>
        <p>2. 用户不得对本公司软件产品进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）等行为，违者属于侵权，用户应自行承担由此产生的不利后果。且本公司有权采取必要措施并追究用户责任。</p>
        <p>3. 本公司软件产品保证不含任何病毒，木马等破坏用户数据的恶意代码。但是由于本公司软件产品可以通过网络等途径下载、传播，对于从非软件作者指定站点下载的软件产品，软件作者无法保证该软件是否感染计算机病毒、是否隐藏有伪装的特洛伊木马程序或者黑客软件，本公司不承担由此引起任何的直接和间接损害责任。</p>
        <p>4. 本公司软件产品会不断更新，以便及时为用户提供新功能和修正软件中的BUG。同时本公司保证软件在升级过程中也不含有任何旨在破坏用户计算机数据的恶意代码。</p>
        <p>5. 由于用户计算机软硬件环境的差异性和复杂性，本公司软件产品所提供的各项功能并不能保证在任何情况下都能正常执行或达到用户所期望的结果。用户使用本公司软件产品所产生的一切后果，本公司不承担任何责任。</p>
        <p>6. 用户使用本公司软件产品，因电信系统或互联网网络故障、计算机故障或病毒、信息损坏或丢失、计算机系统问题或其它任何不可抗力原因而产生的损失，本公司不承担任何责任。</p>
        <p>7. 任何单位或个人认为本公司提供的软件涉嫌侵犯其合法权益，应该及时向本公司书面反馈，并提供身份证明、权属证明及详细侵权情况证明，本公司在收到上述法律文件后，将会尽快移除被控侵权软件。</p>
        <p>8. 因本公司软件产品引起的或有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至本公司住所地法院解决。</p>
        <p>9. 如果用户自行下载运行本公司软件产品，即表明用户信任软件作者，自愿选择安装软件并接受本协议所有条款。本公司对任何原因在使用本公司提供的软件时可能对用户自己或他人造成的任何形式的损失和伤害不承担责任。如果用户不接受本协议，请立即删除。</p>
        <p>10. 本声明适用于本公司旗下的所有软件。如果您使用本公司旗下的任一软件，那么视为您接受本声明。</p>
        <p>11. 本声明的一切说明权与修改权归本公司。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.disclaimer-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content-text {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;

      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>
